import React, { useState, useContext, useEffect } from "react";
// import { Alert } from "react-native";
import "./Care.css";
import Mobile from "../../component/mobile/mobile";
import { useParams } from "react-router-dom";

import carebanner from "../../assets/banner2.jpg";
import productimage1 from "../../assets/service3.png";
import priceimage from "../../assets/SVG.png";
import designationimage from "../../assets/mdi_education-outline.png";
import {
  Subservicevariant,
  TotalPriceCalculation,
  Alladdressdetails,
  Nursingbooking,
  SubserviceVariantPrices,
  GetAddress,
  CheckServiceAvailability,
  Locationdetails,
  UpdateAddresses,
  NewAddress,
  cityDetails,
  districtDetails,
  stateDetails,
} from "../../env/action";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import debounce from "lodash.debounce";

export default function Care() {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => setShowModal(true);
  const [newAddressModal, setNewAddressModal] = useState(false);
  const handleNewAddressModal = () => setNewAddressModal(true);
  const handleModalClose = () => setShowModal(false);
  const [loading, setLoading] = useState(false);
  const { timeperiodid } = useParams();
  const [selectedVariant, setSelectedVariant] = useState([]);
  const { token, userData, service_id, subservice_id, timeperiod_id } =
    useContext(UserContext);
  const [addresses, setAddresses] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [subserviceVarientId, setSubserviceVarientId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const today = new Date().toISOString().split("T")[0]; // format: YYYY-MM-DD
  const [selectedPlan, setSelectedPlan] = useState("");
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [address_id, setAddressId] = useState(null);
  const [fullname, setFullname] = useState("");
  const [contact, setContact] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [locality, setLocality] = useState("");
  const [isServiceAvailable, setIsServiceAvailable] = useState(false);
  const [pincodeError, sertPincodeError] = useState("");

  const user = localStorage.getItem("userData");
  let userdetails = null;

  if (user) {
    userdetails = JSON.parse(user);
  } else {
    console.log("No user data found in localStorage.");
  }
  const storedServiceId = localStorage.getItem("service_id");
  const storedSubserviceId = localStorage.getItem("subservice_id");
  const storedTimeperiodId = localStorage.getItem("timeperiod_id");
  const subServiceName = localStorage.getItem("selectedSubserviceName");

  const [cityEditableManually, setCityEditableManually] = useState(false);
  const [distEditableManually, setDistEditableManually] = useState(false);
  const [stateEditableManually, setStateEditableManually] = useState(false);

  const [citySuggestions, setCitySuggestions] = useState([]);
  const [districtSuggestions, setDistrictSuggestions] = useState([]);
  const [stateSuggestions, setStateSuggestions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const params = {
        service_id: storedServiceId,
        subservice_id: storedSubserviceId,
        timepackage_id: storedTimeperiodId,
      };
      console.log(params, "-----Fetching Subservicevariant...");

      Subservicevariant(params, (res) => {
        if (res.status === 1 && res.data.length > 0) {
          setSelectedVariant(res.data);
        } else {
          console.log("No time period found");
        }
        setLoading(false);
      });
    };

    fetchData();
  }, [timeperiodid]);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    Alladdressdetails(token, (res) => {
      if (res.status === 1 && res.addresses?.length > 0) {
        setAddresses(res.addresses);
        const defaultAddr = res.addresses.find(
          (addr) => addr.type === "default"
        );
        if (defaultAddr) {
          setSelectedAddress(defaultAddr);
        }
      } else {
        console.warn("No addresses found");
      }
      setLoading(false);
    });
  }, [token]);

  useEffect(() => {
    if (editingAddressId) {
      fetchAddressData(editingAddressId);
    }
  }, [editingAddressId]);

  const fetchAddressData = (addressid) => {
    GetAddress(token, addressid, (res) => {
      if (res.status === 1) {
        const data = res.data;
        setFullname(data.name || "");
        setContact(data.mobile?.toString() || "");
        setPincode(data.pincode || "");
        setState(data.state || "");
        setDistrict(data.dist || "");
        setCity(data.city || "");
        setAddress(data.address || "");
        setLocality(data.locality || "");
        setIsServiceAvailable(true);
      } else {
        alert("Failed to fetch address details.");
      }
    });
  };
  const handlePincode = (pincode) => {
    setPincode(pincode);
    if (pincode.length !== 6) {
      sertPincodeError("Pincode must be 6 digits");
    } else {
      sertPincodeError("");
    }
  };
  const checkServiceAvailability = (cityName) => {
    return new Promise((resolve) => {
      if (!cityName) return resolve(false);

      const params = { city: cityName };

      CheckServiceAvailability(params, (res) => {
        if (res.status === 1) {
          setIsServiceAvailable(true);
          resolve(true);
        } else {
          setIsServiceAvailable(false);
          alert(res.message, "", [
            {
              text: "OK",
              onPress: () => {
                setPincode(null);
                setCity(null);
                setDistrict(null);
                setState(null);
                setCitySuggestions([]);
                setDistrictSuggestions([]);
                setStateSuggestions([]);
                resolve(false);
              },
            },
          ]);
        }
      });
    });
  };

  const fetchSuggestions = debounce((type, query) => {
    if (!query || query.trim() === "") {
      if (type === "city") setCitySuggestions([]);
      if (type === "district") setDistrictSuggestions([]);
      if (type === "state") setStateSuggestions([]);
      return;
    }
    console.log("Debounced FetchSuggestions:", type, query);

    const callback = (res) => {
      console.log(res, "city response");

      if (res.status === 1) {
        if (type === "city") setCitySuggestions(res.data);
        if (type === "district") setDistrictSuggestions(res.data);
        if (type === "state") setStateSuggestions(res.data);
      } else {
        console.warn(`No ${type} suggestions found`);
      }
    };

    try {
      if (type === "city") {
        cityDetails(query, callback);
      } else if (type === "district") {
        districtDetails(query, callback);
      } else if (type === "state") {
        stateDetails(query, callback);
      }
    } catch (error) {
      console.error(`Error fetching ${type} suggestions:`, error);
    }
  }, 300);

  const fetchLocationDetails = (pincode) => {
    try {
      Locationdetails({ pincode }, (response) => {
        if (!response || typeof response.status === "undefined") {
          console.error("Invalid response from Locationdetails:", response);
          toast.error("Something went wrong. Please try again.");
          return;
        }

        if (
          response.data.city === "" &&
          response.data.district === "" &&
          response.data.state === ""
        ) {
          sertPincodeError("Invalid Pincode");
        } else {
          sertPincodeError("");
        }

        setCity(response.data.city);
        setDistrict(response.data.district);
        setState(response.data.state);

        setCityEditableManually(response.data.city === "");
        setDistEditableManually(response.data.district === "");
        setStateEditableManually(response.data.state === "");
        if (response.data.city) {
          checkServiceAvailability(response.data.city);
        }
      });
    } catch (error) {
      console.error("Error fetching location:", error);
      toast.error("Something went wrong while fetching location data.");
    }
  };
  const handleAddressUpdate = async () => {
    // if (!isServiceAvailable) {
    //     alert("You cannot proceed as services are not available in this city.");
    //     return;
    // }
    if (!state || state.trim() === "") {
      alert("Validation Error", "State is required.");
      return;
    }

    if (!district || district.trim() === "") {
      alert("Validation Error", "District is required.");
      return;
    }

    if (!city || city.trim() === "") {
      alert("Validation Error", "City is required.");
      return;
    }

    let serviceOk = true;
    if (cityEditableManually === true) {
      serviceOk = await checkServiceAvailability(city);
    }
    console.log("Service available:", serviceOk);

    if (!serviceOk) {
      return;
    }
    const params = {
      address_id: editingAddressId,
      mobile: contact,
      full_name: fullname,
      address: address,
      locality: locality,
      pincode: pincode,
      state: state,
      dist: district,
      city: city,
    };
    UpdateAddresses(params, token, (res) => {
      if (res) {
        if (res.status === 0) {
          alert(res.message);
        } else {
          alert(res.message);
          window.location.reload();
        }
      } else {
        alert("Unexpected response from server.");
      }
    });
  };

  const handleNewAddress = async () => {
    console.log("Sign Up function");
    // if (!isServiceAvailable) {
    //     alert("You cannot proceed as services are not available in this city.");
    //     return;
    // }
    if (!state || state.trim() === "") {
      alert("Validation Error", "State is required.");
      return;
    }

    if (!district || district.trim() === "") {
      alert("Validation Error", "District is required.");
      return;
    }

    if (!city || city.trim() === "") {
      alert("Validation Error", "City is required.");
      return;
    }

    let serviceOk = true;
    if (cityEditableManually === true) {
      serviceOk = await checkServiceAvailability(city);
    }
    console.log("Service available:", serviceOk);

    if (!serviceOk) {
      return;
    }
    const params = {
      mobile: userdetails.phone_number,
      full_name: userdetails.name,
      address: address,
      locality: locality,
      pincode: pincode,
      state: state,
      dist: district,
      city: city,
    };
    NewAddress(params, token, (res) => {
      if (res) {
        if (res.status === 0) {
          alert(res.message);
        } else {
          alert(res.message);
          window.location.reload();
        }
      } else {
        alert("Unexpected response from server.");
      }
    });
  };

  const fetchServicePrice = (plan) => {
    const param = {
      subservice_variant_id: subserviceVarientId,
    };

    SubserviceVariantPrices(param, (res) => {
      if (res?.status === 1) {
        if (plan == "Day") {
          setSelectedPrice(res.data.daily_price);
          setNumberOfDays(0);
          setTotalAmount(0);
          setFromDate("");
          setToDate("");
        } else if (plan == "Weekly") {
          const perDayPrice = parseFloat(
            (res.data.weekly_price / 7).toFixed(2)
          );
          setSelectedPrice(perDayPrice);
          // setSelectedPrice(res.data.weekly_price);
          setNumberOfDays(0);
          setTotalAmount(0);
          setFromDate("");
          setToDate("");
        } else {
          const perDayPrice = parseFloat(
            (res.data.monthly_price / 30).toFixed(2)
          );
          setSelectedPrice(perDayPrice);
          // setSelectedPrice(res.data.monthly_price);
          setNumberOfDays(0);
          setTotalAmount(0);
          setFromDate("");
          setToDate("");
        }
      } else {
        alert("Please select any subservice variant.");
      }
    });
  };

  const calculateDays = (start, end) => {
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const timeDiff = endDate.getTime() - startDate.getTime();

      const days =
        timeDiff >= 0 ? Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1 : 0;
      setNumberOfDays(days);
    } else {
      setNumberOfDays(0);
    }
  };

  useEffect(() => {
    if (numberOfDays > 0 && selectedPrice) {
      setLoading(true);

      const params = {
        service_price: selectedPrice,
        no_of_days: numberOfDays,
      };

      TotalPriceCalculation(params, (res) => {
        const total = parseInt(res.total_price);
        setTotalAmount(parseFloat(total.toFixed(2)));
        // setTotalAmount(res.total_price);
        setLoading(false);
      });
    }
  }, [numberOfDays, selectedPrice]);

  const handleBookingdetails = () => {
    if (!token) {
      alert("Please login before booking.");
      return;
    }
    if (!selectedAddress) {
      alert("Please select an address.");
      return;
    }
    if (!subserviceVarientId) {
      alert("Please choose varient.");
      return;
    }
    if (!selectedPlan) {
      alert("Please choose plan.");
      return;
    }
    if (!fromDate) {
      alert("Please Select from date.");
      return;
    }
    if (!toDate) {
      alert("Please Select end date.");
      return;
    }

    const params = {
      user_id: userData.user_id,
      service_id: service_id,
      subservice_id: subservice_id,
      subservices_variant_id: subserviceVarientId,
      address_type: selectedAddress.type,
      address_id: selectedAddress.address_id,
      timepackage_id: storedTimeperiodId,
      plan_type: selectedPlan,
      start_date: fromDate,
      end_date: toDate,
      service_price: selectedPrice,
      total_days: numberOfDays,
      total_amount: totalAmount,
      source: "WEB",
    };
    Nursingbooking(params, token, (res) => {
      if (res) {
        if (res.status === 0) {
          toast.error(res.message);
        } else {
          toast.success(res.message);
          navigate("/");
        }
      } else {
        toast.error("Unexpected response from server.");
      }
    });
  };

  return (
    <>
      <div className="care-banner">
        <img src={carebanner} alt="Care Banner" className="banner-img" />
      </div>
      <div className="nursingCare">
        <p className="text-center fw-bolder text-1">
          {subServiceName} for 24x7 Care
        </p>
      </div>

      <div className="product-slider-container">
        <div className="row justify-content-center">
          {selectedVariant.map((variant, index) => (
            <div className="col-md-3" key={variant.subservicevariant_id}>
              <div
                className={`products-cards ${
                  selectedCard === index + 1 ? "selected-card" : ""
                }`}
              >
                <div className="pronurse">
                  <img src={variant.icon} className="pronurse-image" />
                </div>

                <h3>{variant.designation}</h3>
                <h5>
                  <span>
                    <img src={designationimage} className="product-icon" />
                  </span>
                  {variant.experience}
                </h5>

                <p>
                  <span>
                    <img src={priceimage} className="product-icon" />
                  </span>
                  Starting Rs. {variant.starting_price}/- Day
                </p>
                <button
                  className="view-button1"
                  onClick={() => {
                    setSelectedCard(index + 1);
                    setSubserviceVarientId(variant.subservicevariant_id);
                    setSelectedPlan("");
                    setTotalAmount(0);
                    setSelectedPrice(0);
                    setNumberOfDays(0);
                    setFromDate("");
                    setToDate("");
                  }}
                >
                  Choose
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-9">
            <div className="addpay border rounded shadow-sm">
              <div className="row justify-content-center">
                <div className="col-md-5">
                  <h5 className="defaultnam">Default Address</h5>
                  <div className="addsec">
                    {loading ? (
                      <p>Loading addresses...</p>
                    ) : !token ? (
                      <p className="text-danger">
                        Please Login and update your address.
                      </p>
                    ) : addresses.length === 0 ? (
                      <p className="text-warning">No addresses found.</p>
                    ) : (
                      addresses.map((addr, index) => (
                        <div className="delivery-address-card" key={index}>
                          <div className="deliradio">
                            <input
                              type="radio"
                              name="selectedAddress"
                              className="form-check-input me-3 mt-1"
                              style={{ scale: "1.2" }}
                              // defaultChecked={addr.type === "default"}
                              checked={
                                selectedAddress?.address_id === addr.address_id
                              }
                              onChange={() => setSelectedAddress(addr)}
                            />
                            <div className="addrsspart">
                              <div className="address-header d-flex align-items-center justify-content-between">
                                <strong>{addr.name}</strong>
                                <span
                                  className="badge bg-light text-dark border border-success rounded-pill px-2 py-1"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {addr.type}
                                </span>
                              </div>
                              <div className="address-body mt-2">
                                <p className="mb-1">
                                  {addr.address}, {addr.locality},<br />
                                  {addr.city}, {addr.state} - {addr.pincode}
                                </p>
                              </div>
                              {addr.type !== "default" && (
                                <div className="address-actions d-flex gap-2">
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => {
                                      setEditingAddressId(addr.address_id);
                                      handleModalOpen();
                                    }}
                                  >
                                    Edit
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  <div className="mt-3">
                    <button
                      className="btn btn-link text-danger"
                      style={{ textDecoration: "none" }}
                      onClick={() => {
                        handleNewAddressModal();
                      }}
                    >
                      + Add New Address
                    </button>
                  </div>
                </div>

                <div className="col-md-6 mt-4">
                  <div className="d-flex gap-5 mb-3 border rounded p-4">
                    {["Day", "Weekly", "Monthly"].map((plan) => (
                      <label
                        key={plan}
                        className="d-flex align-items-center gap-2"
                      >
                        <input
                          type="radio"
                          name="plan"
                          value={plan}
                          checked={selectedPlan === plan}
                          onChange={() => {
                            setSelectedPlan(plan);
                            fetchServicePrice(plan);
                          }}
                        />
                        <span>{plan}</span>
                      </label>
                    ))}
                  </div>

                  <div className="calendar-container p-3">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="selectDate"
                          className="form-label fw-bold mb-2"
                        >
                          From Date
                        </label>
                        <input
                          type="date"
                          id="fromDate"
                          min={today}
                          className="form-control"
                          value={fromDate}
                          onChange={(e) => {
                            const newFromDate = e.target.value;
                            setFromDate(newFromDate);
                            let autoToDate = "";

                            if (selectedPlan === "Weekly") {
                              const date = new Date(newFromDate);
                              date.setDate(date.getDate() + 6);
                              autoToDate = date.toISOString().split("T")[0];
                              setToDate(autoToDate);
                              calculateDays(newFromDate, autoToDate);
                            } else if (selectedPlan === "Monthly") {
                              const date = new Date(newFromDate);
                              date.setDate(date.getDate() + 29);
                              autoToDate = date.toISOString().split("T")[0];
                              setToDate(autoToDate);
                              calculateDays(newFromDate, autoToDate);
                            } else {
                              calculateDays(newFromDate, toDate);
                            }
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="selectDate"
                          className="form-label fw-bold mb-2"
                        >
                          To Date
                        </label>
                        <input
                          type="date"
                          id="toDate"
                          min={today}
                          className="form-control"
                          value={toDate}
                          onChange={(e) => {
                            const newToDate = e.target.value;
                            if (fromDate && newToDate < fromDate) {
                              alert("To Date cannot be before From Date.");
                              return;
                            }
                            setToDate(e.target.value);
                            calculateDays(fromDate, e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="price-details-card border rounded p-3">
                    <h6 className="mb-3 fw-bold">PRICE DETAILS</h6>
                    <div className="d-flex justify-content-between mb-2">
                      <span>Service Price</span>
                      <span>₹{selectedPrice || "0"}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-success">
                      <span>Number Of Days</span>
                      <span>{numberOfDays}</span>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between fw-bold mb-3">
                      <span>Total Amount</span>
                      <span>
                        {loading ? "Calculating..." : `₹${totalAmount || 0}`}
                      </span>
                    </div>
                    <button
                      className="btn btn-danger w-100 fw-bold"
                      onClick={handleBookingdetails}
                    >
                      Booking Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Address</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form className="formsec">
                  <div>
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={fullname}
                      readOnly
                      onChange={(e) => setFullname(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="form-label">Contact Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={contact}
                      readOnly
                      onChange={(e) => setContact(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      value={pincode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setPincode(value);
                          handlePincode(value);
                          if (value.length === 6) {
                            fetchLocationDetails(value);
                          }
                        }
                      }}
                    />
                    {pincodeError && (
                      <p
                        className="text-danger mt-1 mb-0"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {pincodeError}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      value={state}
                      // onChange={(e) => setState(e.target.value)}
                      onChange={(e) => {
                        const text = e.target.value;
                        setState(text);

                        if (stateEditableManually) {
                          if (text.trim() === "") {
                            setStateSuggestions([]);
                          } else {
                            fetchSuggestions("state", text);
                          }
                        }
                      }}
                      disabled={!stateEditableManually}
                    />
                    {stateSuggestions.length > 0 && (
                      <ul
                        className="suggestions-list"
                        style={{
                          listStyleType: "none",
                          padding: 0,
                          margin: 0,
                          border: "1px solid #ccc",
                          borderTop: "none",
                          position: "absolute",
                          width: "100%",
                          backgroundColor: "white",
                          zIndex: 10,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }}
                      >
                        {stateSuggestions.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setState(item.state_name);
                              setStateSuggestions([]);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f1f1f1")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor = "white")
                            }
                          >
                            {item.state_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div>
                    <label className="form-label">District</label>
                    <input
                      type="text"
                      className="form-control"
                      value={district}
                      // onChange={(e) => setDistrict(e.target.value)}
                      onChange={(e) => {
                        const text = e.target.value;
                        setDistrict(text);

                        if (distEditableManually) {
                          if (text.trim() === "") {
                            setDistrictSuggestions([]);
                          } else {
                            fetchSuggestions("district", text);
                          }
                        }
                      }}
                      disabled={!distEditableManually}
                    />
                    {districtSuggestions.length > 0 && (
                      <ul
                        className="suggestions-list"
                        style={{
                          listStyleType: "none",
                          padding: 0,
                          margin: 0,
                          border: "1px solid #ccc",
                          borderTop: "none",
                          position: "absolute",
                          width: "100%",
                          backgroundColor: "white",
                          zIndex: 10,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }}
                      >
                        {districtSuggestions.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setDistrict(item.dist_name);
                              setDistrictSuggestions([]);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f1f1f1")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor = "white")
                            }
                          >
                            {item.dist_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div>
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={city}
                      // onChange={(e) => setCity(e.target.value)}
                      onChange={(e) => {
                        const text = e.target.value;
                        setCity(text);

                        if (cityEditableManually) {
                          if (text.trim() === "") {
                            setCitySuggestions([]);
                          } else {
                            fetchSuggestions("city", text);
                          }
                        }
                      }}
                      disabled={!cityEditableManually}
                    />
                    {citySuggestions.length > 0 && (
                      <ul
                        className="suggestions-list"
                        style={{
                          listStyleType: "none",
                          padding: 0,
                          margin: 0,
                          border: "1px solid #ccc",
                          borderTop: "none",
                          position: "absolute",
                          width: "100%",
                          backgroundColor: "white",
                          zIndex: 10,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }}
                      >
                        {citySuggestions.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setCity(item.city_name);
                              setCitySuggestions([]);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f1f1f1")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor = "white")
                            }
                          >
                            {item.city_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div>
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    ></textarea>
                  </div>
                  <div>
                    <label className="form-label">Locallity</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={locality}
                      onChange={(e) => setLocality(e.target.value)}
                    ></textarea>
                  </div>
                </form>
              </div>
              <div className="modal-footer text-center">
                <button
                  type="button"
                  className="btn btn-primary savbtn"
                  onClick={handleAddressUpdate}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {newAddressModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">New Address</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setNewAddressModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form className="formsec">
                  <div>
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={userdetails.name}
                      readOnly
                      onChange={(e) => setFullname(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="form-label">Contact Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={userdetails.phone_number}
                      readOnly
                      onChange={(e) => setContact(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      value={pincode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setPincode(value);
                          handlePincode(value);
                          if (value.length === 6) {
                            fetchLocationDetails(value);
                          }
                        }
                      }}
                    />
                    {pincodeError && (
                      <p
                        className="text-danger mt-1 mb-0"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {pincodeError}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      value={state}
                      // onChange={(e) => setState(e.target.value)}
                      onChange={(e) => {
                        const text = e.target.value;
                        setState(text);

                        if (stateEditableManually) {
                          if (text.trim() === "") {
                            setStateSuggestions([]);
                          } else {
                            fetchSuggestions("state", text);
                          }
                        }
                      }}
                      disabled={!stateEditableManually}
                    />
                  </div>
                  {stateSuggestions.length > 0 && (
                    <ul
                      className="suggestions-list"
                      style={{
                        listStyleType: "none",
                        padding: 0,
                        margin: 0,
                        border: "1px solid #ccc",
                        borderTop: "none",
                        position: "absolute",
                        width: "100%",
                        backgroundColor: "white",
                        zIndex: 10,
                        maxHeight: "150px",
                        overflowY: "auto",
                      }}
                    >
                      {stateSuggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setState(item.state_name);
                            setStateSuggestions([]);
                          }}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#f1f1f1")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "white")
                          }
                        >
                          {item.state_name}
                        </li>
                      ))}
                    </ul>
                  )}
                  <div>
                    <label className="form-label">District</label>
                    <input
                      type="text"
                      className="form-control"
                      value={district}
                      // onChange={(e) => setDistrict(e.target.value)}
                      onChange={(e) => {
                        const text = e.target.value;
                        setDistrict(text);

                        if (distEditableManually) {
                          if (text.trim() === "") {
                            setDistrictSuggestions([]);
                          } else {
                            fetchSuggestions("district", text);
                          }
                        }
                      }}
                      disabled={!distEditableManually}
                    />
                    {districtSuggestions.length > 0 && (
                      <ul
                        className="suggestions-list"
                        style={{
                          listStyleType: "none",
                          padding: 0,
                          margin: 0,
                          border: "1px solid #ccc",
                          borderTop: "none",
                          position: "absolute",
                          width: "100%",
                          backgroundColor: "white",
                          zIndex: 10,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }}
                      >
                        {districtSuggestions.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setDistrict(item.dist_name);
                              setDistrictSuggestions([]);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f1f1f1")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor = "white")
                            }
                          >
                            {item.dist_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div>
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={city}
                      // onChange={(e) => setCity(e.target.value)}
                      onChange={(e) => {
                        const text = e.target.value;
                        setCity(text);

                        if (cityEditableManually) {
                          if (text.trim() === "") {
                            setCitySuggestions([]);
                          } else {
                            fetchSuggestions("city", text);
                          }
                        }
                      }}
                      disabled={!cityEditableManually}
                    />
                    {citySuggestions.length > 0 && (
                      <ul
                        className="suggestions-list"
                        style={{
                          listStyleType: "none",
                          padding: 0,
                          margin: 0,
                          border: "1px solid #ccc",
                          borderTop: "none",
                          position: "absolute",
                          width: "100%",
                          backgroundColor: "white",
                          zIndex: 10,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }}
                      >
                        {citySuggestions.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setCity(item.city_name);
                              setCitySuggestions([]);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f1f1f1")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor = "white")
                            }
                          >
                            {item.city_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div>
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    ></textarea>
                  </div>
                  <div>
                    <label className="form-label">Locallity</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={locality}
                      onChange={(e) => setLocality(e.target.value)}
                    ></textarea>
                  </div>
                </form>
              </div>
              <div className="modal-footer text-center">
                <button
                  type="button"
                  className="btn btn-primary savbtn"
                  onClick={handleNewAddress}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Mobile />
    </>
  );
}
